import React, {useEffect, useMemo, useState} from 'react';
import Select from 'react-select';
import SelectSvgSelector from './SelectSvgSelector';
import CustomSelect from '../Select/CustomSelect';

const OrderTypeDeliverySelect = ({
	setFieldValue,
	currentDeliveryType,
}: {
	setFieldValue: any;
	currentDeliveryType?: string;
}) => {
	const [value, setValue] = useState({
		label: 'Адреса',
		value: 'getStreet',
		deliveryType: 'door',
	});
	const options = useMemo(
		() => [
			{label: 'Відділення', value: 'getWarehouses', deliveryType: 'branch'},
			{label: 'Адреса', value: 'getStreet', deliveryType: 'door'},
			{label: 'Поштомат', value: 'getPostomats', deliveryType: 'ware'},
		],
		[],
	);
    useEffect(() => {
        if (!currentDeliveryType) return;
        const next = options.find((o) => o.deliveryType === currentDeliveryType);
        if (next) {
            setValue(next as any);
            // Keep Formik in sync so dependent components (e.g., address search) use correct NP method
            setFieldValue('delivery_typeForNP', (next as any).value);
            setFieldValue('delivery_type', (next as any).deliveryType);
        }
    }, [currentDeliveryType, options, setFieldValue]);

	return (
		<CustomSelect
			value={value}
			onChange={(newValue) => {
				setValue(
					newValue ? newValue : {label: '', value: '', deliveryType: ''},
				);
				setFieldValue('delivery_typeForNP', newValue?.value);
				setFieldValue('delivery_type', newValue?.deliveryType);
			}}
			options={options}
		/>
	);
};

export default OrderTypeDeliverySelect;
